import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import TextBlock from 'libs/wordpress/content/cmsBlocks/TextBlock';
import colors from 'config/theme/colors';
import moduleMargins from 'config/theme/moduleMargins';
import { moduleSettingsProp } from 'utils/proptypes/modules/settingsProps';

const TextLayout = ({ last = false, settings = {}, ...rest }) => {
    const { background_color: backgroundColor, text_color: textColor } = settings;

    return (
        <MaxWidthWrapper
            includeContentMargins
            as="section"
            backgroundColor={backgroundColor}
            borderBottom={!last ? `1px solid ${colors.black}` : null}
            py={moduleMargins.md}
        >
            <TextBlock columnBase={12} columnSizes={[12, null, null, null, 6]} moduleTextColor={textColor} {...rest} />
        </MaxWidthWrapper>
    );
};

TextLayout.propTypes = {
    content: PropTypes.array,
    last: PropTypes.bool,
    settings: moduleSettingsProp,
};

export default TextLayout;
